import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  animatedVideoIcon,
  socialMediaVideoIcon,
  corporateVideoIcon,
  podcastVideoIcon,
  tutorialVideoIcon,
} from "../../../../assets/icons/serviceIcon/index";
import YooutubeVideoWork from "./YooutubeVideoWork";

const items = [
  {
    name: "Full-Length Video Editing",
    text: "Edit long-form videos with smooth transitions, clean cuts, intro-outro and proper pacing to keep your audience engaged from start to finish.",
  },
  {
    name: "Basic Animations & Text Overlays",
    text: "Add dynamic lower-thirds, titles, and pop-up text elements that support your message and make your videos easier to follow visually.",
  },
  {
    name: "Thumbnails & Final Exports",
    text: "Create custom thumbnails and export videos in the right resolution, aspect ratio, and file size, fully ready to upload to YouTube.",
  },
];

const otherService = [
  {
    icon: socialMediaVideoIcon,
    name: "Social Media Videos",
    des: "From raw videos to scroll-ready IG Reels and YT Shorts",
    path: "/social-media-videos",
  },
  {
    icon: animatedVideoIcon,
    name: "Animated Videos",
    des: "Engaging animated videos that simplify ideas and grab attention.",
    path: "/animated-videos",
  },
  {
    icon: corporateVideoIcon,
    name: "Corporate & Business Videos",
    des: "Polished business videos for presentations and internal brand communication",
    path: "/corporate-and-business-video",
  },
  {
    icon: podcastVideoIcon,
    name: "Podcast & Interview Editing",
    des: "Clean edits, smooth flow, and visuals that make content shine.",
    path: "/podcast-and-interview-editing",
  },
  {
    icon: tutorialVideoIcon,
    name: "Explainer & Tutorial Videos",
    des: "Break down complex ideas into simple, easy-to-follow video explanations.",
    path: "/explainer-tutorial-video",
  },
];
const YoutubeVideo = () => {
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Editing"
        description="From raw footage to professional YouTube videos, we handle the cuts, pacing, effects, and polish that keep viewers watching and your channel looking consistent."
        heading="YouTube Video"
      />
      <NewCommonServiceForm title="YouTube Video Editing" items={items} />
      <YooutubeVideoWork/>
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default YoutubeVideo;
